import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useExploreStore } from '@/explore/ExploreStore'
import { LoadMode } from '@/util/AsyncData'
import { PrincipalType } from '@/gp/GroupAdminModel'

// these pages represent the share action, so the button should NOT be shown in the header
const hideShareActionPages = [
    /^\/groups\/.+/,
    /^\/plans/,
]
export function useShareAction() {
    const router = useRouter()
    const userStore = useUserStore()
    const dataGroupStore = useDataGroupStore()
    const dataGroupMemberStore = useDataGroupMemberStore()
    const exploreStore = useExploreStore()
    
    const selfRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
    const allowShareRef = computed(() => selfRef.value?.limitsDisabled || (selfRef.value?.limits?.sharingLimit ?? 0) > 0)
    const showShareActionRef = computed(() => {
        if (!exploreStore.hasViewedTree || 
            hideShareActionPages.some(p => p.test(router.currentRoute.value.path)))
            return false

        const ownedResearchGroups = dataGroupStore.getOwnedResearchGroups(LoadMode.EnsureLoaded)
        if (ownedResearchGroups.length == 0)
            return false // no owned groups

        const ownedGroupIds = ownedResearchGroups.map(rg => rg.id!)
        const sharedGroupIds = dataGroupMemberStore.getMembersForDataGroups(ownedGroupIds, LoadMode.EnsureLoaded)
            .filter(m => m.principalType == PrincipalType.FamilyGroup)
            .map(m => m.dataGroupId!)
        return sharedGroupIds.length == 0 // none shared yet
    })

    return {
        showShareActionRef,
    }
}
